import React, { useEffect } from "react";
import Textarea from "@peracto/peracto-editor-ui/dist/Textarea";
import File from "@peracto/peracto-editor-ui/dist/File";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-regular-svg-icons/faTrash";
import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons/faPlusCircle";

const USPBlockForm = ({
    onChange,
    state: { usps = [], selectedCardIndex },
}) => {
    const DEFAULT_USP = {
        icon: "",
        content: "<p>Describe this USP...</p>",
    };

    useEffect(() => {
        return () => {
            onChange({ selectedCardIndex: null });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {usps?.length === 0 && (
                <>
                    <p>Click 'Add USP' to get started</p>
                    <hr />
                </>
            )}

            {selectedCardIndex !== null && usps && usps[selectedCardIndex] && (
                <>
                    <File
                        label="Icon"
                        value={usps[selectedCardIndex].icon || ""}
                        onChange={(value) => {
                            const uspsClone = [...usps];
                            uspsClone[selectedCardIndex].icon = value;

                            onChange({
                                usps: uspsClone,
                            });
                        }}
                        isInline={false}
                    />

                    <Textarea
                        label="Content"
                        value={usps[selectedCardIndex].content}
                        height={300}
                        onChange={(e, editor) => {
                            const uspsClone = [...usps];
                            uspsClone[selectedCardIndex].content =
                                editor.getData();

                            onChange({
                                usps: uspsClone,
                            });
                        }}
                    />

                    <button
                        className="btn btn-sm btn-danger w-100 mt-2"
                        onClick={(e) => {
                            e.preventDefault();
                            const uspsClone = [...usps];

                            uspsClone.splice(selectedCardIndex, 1);

                            onChange({
                                usps: uspsClone,
                                selectedCardIndex:
                                    uspsClone.length > 0
                                        ? Math.max(0, selectedCardIndex - 1)
                                        : null,
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} className="mr-2" />{" "}
                        Remove USP
                    </button>
                </>
            )}

            <hr className="my-2" />

            <button
                className="btn btn-sm btn-secondary w-100"
                onClick={(e) => {
                    e.preventDefault();

                    const uspsClone = [...usps, DEFAULT_USP];
                    onChange({
                        usps: uspsClone,
                        selectedCardIndex: uspsClone.length - 1,
                    });
                }}
            >
                <FontAwesomeIcon icon={faPlusCircle} className="mr-2" /> Add USP
            </button>
        </>
    );
};

export default USPBlockForm;
